import { Component } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AuthService } from '../../Service/app-service';
import { SearchPipe } from '../../search-pipe.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-set-ringtone',
  standalone: true,
  imports: [CommonModule, FormsModule,ReactiveFormsModule,NgxSpinnerModule,],
  templateUrl: './set-ringtone.component.html',
  styleUrl: './set-ringtone.component.css'
})
export class SetRingtoneComponent {
  openConfirmChnagePopup: boolean = false;
  toBeEditedTagId: any;
  showContentConfiguration: boolean = false;
  Generes: boolean = true;
  genreForm: any;
  statusChangeText: any;
  showSubscription: boolean = true;
  filteredTransactions: any[] = [];
  currentPage: number = 1;
  searchQuery: string = '';
  rowsPerPage: number = 5;
  paginatedTransactions: any[] = [];
  pageSizes: number[] = [5, 10, 20];
  songs: any[] = [];
  errorMessage: string = '';
  transactions = [];
  // spinnerService: any;
  selectedTransaction: any = null;
  musicName: string = '';
  currencyMapping: { [key: string]: number } = {
    ZWG: 2,
    USD: 1,
  };
  totalPages: number = 1;
  selectedCurrencyId: number | null = null;
  plans: any[] = [];
  userName: string | null = '';
  userid: any;
  useremail: string = '';
  phone!: string | null;
  musicid: any;
  planId: any;
  musicId: any;
  selectedPlanId: any;
  sortField: string | null = null;
  sortDirection: 'asc' | 'desc' | null = null;
  changePasswordForm!: FormGroup;
  email: string = '';
  passwordErrorMessage: string = '';
  successMessage: string = '';
  showOldPassword: boolean = false;
showNewPassword: boolean = false;
showConfirmPassword: boolean = false;
currency:any;
plan:any = '';
  constructor(private modalService: NgbModal, private tosterService : ToastrService, private router: Router, private SpinnerService: NgxSpinnerService, private authService: AuthService, private fb: FormBuilder) {
  }

  async ngOnInit(): Promise<void> {
  this.SpinnerService.show();
  try {
    await this.fetchSongs();
  } catch (e) {
  } finally {
    this.SpinnerService.hide();
    this.initAfterSongs();
  }
}


  initAfterSongs(): void {
    const nav = history.state || {};

    if (nav.msisdn) {
      this.phone = nav.msisdn;
    } else {
      this.authService.phone$.subscribe(phone => this.phone = phone);
    }

    this.currency = nav.currency || '';

    if (this.currency) {
      this.selectedCurrencyId = this.currency === 'ZWG' ? 2 : 1;

      this.SpinnerService.show();
      this.authService.sendCurrencyId(this.selectedCurrencyId).subscribe(res => {
        if (res.status && res.data) {
          this.plans = res.data;
          const selected = this.plans.find((p: any) => p.planName === nav.plan);
          if (selected) {
            this.plan = selected.id || null;
            this.selectedPlanId = selected.id;
          }
        }
        this.SpinnerService.hide();
      });
    }

    this.userName = this.authService.getUserName() || 'Guest';
    this.userid = this.authService.getUserid();
    this.useremail = this.authService.getUseremail() || '';

    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.pattern('(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
          this.differentFromOldPasswordValidator('oldPassword')
        ]
      ],
      confirmPassword: ['', Validators.required]
    }, { validators: this.mustMatch('newPassword', 'confirmPassword') });
  }

  onCancelchange(): void {
    this.changePasswordForm.reset();
    this.modalService.dismissAll();
  }
  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }
  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }
  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }
  differentFromOldPasswordValidator(oldPasswordControlName: string) {
    return (control: any) => {
      const formGroup = control?.parent;
      if (!formGroup) {
        return null;
      }

      const oldPassword = formGroup.get(oldPasswordControlName)?.value;
      const newPassword = control.value;

      if (oldPassword && newPassword === oldPassword) {
        return { sameAsOldPassword: true }; // Custom error
      }

      return null;
    };
  }
  // Custom validator to check if newPassword and confirmPassword match
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ mustMatch: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }
  togglePasswordVisibility(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
  onSubmit(): void {
    console.log("data testing");
    this.SpinnerService.show();
    // Check if the form is valid
    if (this.changePasswordForm.valid) {
      // Extract form values
      const { oldPassword, newPassword, confirmPassword } = this.changePasswordForm.value;

      // Create request body
      const requestBody = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      };

      // Call the changePassword service
      this.email = this.useremail;
      this.authService.changePassword(this.email, requestBody).subscribe({
        next: (response) => {
          console.log('Password change response:', response);
          setTimeout(() => {
            this.clearAuthToken();
            this.modalService.dismissAll();
            this.successMessage = 'Password changed successfully!';
            this.SpinnerService.hide();
            this.tosterService.success(this.successMessage);
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (error) => {
          this.SpinnerService.hide();
          this.tosterService.error(error.error.data);
          console.error('Error changing password:', error);
          // this.passwordErrorMessage = 'Current password is incorrect';
        },
      });
    } else {
      this.SpinnerService.hide();
      this.changePasswordForm.markAllAsTouched();
      console.error('Form is invalid. Please check the inputs.');
    }
  }
  clearAuthToken(): void {
    sessionStorage.removeItem('authToken');
    this.authService.clearPhone();
  }
  
  onPlanSelect(event: any): void {
    this.selectedPlanId = event.target.value;
  }
    getImageUrl(): string {
      return environment.iamge
     }
  AddSong(): void{
    this.SpinnerService.show();
    const PhoneId = this.phone;
    this.planId = this.selectedPlanId;
    this.musicId = this.musicid;
    this.authService.AddSongs(PhoneId,this.planId, this.musicId).subscribe(
      (response) => {
        if (response.statusCode === 200) {
          this.authService.setPhone(PhoneId ?? '');
          if (response.status) {
            // Status is true
            
            this.router.navigate(['/home']).then(() => {
              this.tosterService.success('Song successfully added!');
              // alert('Song successfully added!');
            });
          } else {
            // Status is false
            this.router.navigate(['/home']).then(() => {
              this.tosterService.warning('Song is already exist!');
            // alert('Song is already exist');
            });
          }
          this.modalService.dismissAll();
          this.SpinnerService.hide();
        }else {
          this.SpinnerService.hide();
          this.errorMessage = 'Unexpected response from server';
          this.tosterService.error('Unexpected response from server!');
        }
      },
      (error) => {
        this.SpinnerService.hide();
        this.tosterService.error(error.error.message);
        this.errorMessage = 'Please fill in all the Fields'
        console.error('Error removing account:', error);
      }
    );
  }
  onCancel(): void {
    this.authService.setPhone(this.phone ?? '');
    this.SpinnerService.show();
    this.router.navigate(['/home']);
  }
  onCurrencyChange(event: any): void {
    const selectedCurrency = event.target.value;
    this.selectedCurrencyId = this.currencyMapping[selectedCurrency] || null;
    
    if (this.selectedCurrencyId !== null) {
      this.authService.sendCurrencyId(this.selectedCurrencyId).subscribe({
        next: (response) => {
          console.log('API Response:', response);
          if (response.status && response.data) {
            this.plans = response.data;
          }
        },
        error: (error) => {
          console.error('API Error:', error);
        },
      });
    }
  }
  fetchSongs(): void {
    this.authService.getSongs().subscribe(
      (response: any) => {
        if (response && response.statusCode === 200) {
          // Update transactions and filteredTransactions
          this.transactions = response.data || [];
          this.filteredTransactions = [...this.transactions];
          this.updatePagination(); // Update paginated data
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Failed to fetch details. Please try again.';
        }
      },
      (error) => {
        // Handle API error
        this.errorMessage = error.error?.message || 'An error occurred. Please try again later.';
      }
    );
  }

  filterTransactions(): void {
    let query = this.searchQuery.trim().toLowerCase();

    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
    
        this.filteredTransactions = this.transactions.filter((transaction) => {
          return Object.entries(transaction).some(([key, value]: [string, any]) => {
            // Check if the key is 'date' and format it for comparison
            if (key === 'date' && value) {
              const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
              return formattedDate.toLowerCase().includes(query);
            }
            // Default case for other values
            return value ? value.toString().toLowerCase().includes(query) : false;
          });
        });
    this.currentPage = 1;
    this.updatePagination();
  }

  getStartIndex(): number {
    return (this.currentPage - 1) * this.rowsPerPage + 1;
  }
  getEndIndex(): number {
    const endIndex = this.currentPage * this.rowsPerPage;
    return endIndex > this.filteredTransactions.length ? this.filteredTransactions.length : endIndex;
  }
  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredTransactions.length / this.rowsPerPage) || 1;
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    const endIndex = this.currentPage * this.rowsPerPage;
    this.paginatedTransactions = this.filteredTransactions.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    if (typeof page !== 'number') return;
    this.currentPage = page;
    this.updatePagination();
  }

  getPages(){
    const pages:any[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages - (maxPagesToShow - 2); i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage - halfMaxPagesToShow + 1; i <= this.currentPage + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      }
    }

    return pages;
  }

  isValidPage(page: number | string): page is number {
    return typeof page === 'number';
  }

  sortTransactions(field: string): void {
    if (this.sortField === field) {
      // Toggle sort direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Set new field and default direction to ascending
      this.sortField = field;
      this.sortDirection = 'asc';
    }

    const directionMultiplier = this.sortDirection === 'asc' ? 1 : -1;
    this.filteredTransactions.sort((a, b) => {
      const valueA = a[field] || '';
      const valueB = b[field] || '';
      return valueA > valueB
        ? directionMultiplier
        : valueA < valueB
        ? -directionMultiplier
        : 0;
    });

    this.updatePagination();
  }
  customer(){
     window.history.back();
  }
  onCheckboxChange(transaction: any): void {
    if (this.selectedTransaction === transaction) {
      this.selectedTransaction = null;
      this.musicName = '';
    } else {
      this.selectedTransaction = transaction;
      this.musicName = transaction.songName;
      this.musicid = transaction.id;
    }
    console.log('Selected Transaction:', this.selectedTransaction);
  }
  showSubscriptions(): void {
    this.showSubscription = !this.showSubscription;
  }
  openGeneres() {
    this.Generes = !this.Generes;
    this.showContentConfiguration = false;
  }
  openAddForm(content: any) {
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  logout(): void {
    this.SpinnerService.show();
    const token = sessionStorage.getItem('token');

    if (!token) {
      this.tosterService.error('No token found. Please log in again.');
      this.SpinnerService.hide();
      return;
    }
    this.authService.logout(token).subscribe({
      next: (response) => {
        console.log('Logout successful:', response);
        sessionStorage.removeItem('authToken');
        // this.showToast();
        this.tosterService.success('Logout successfully');
        setTimeout(() => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.router.navigate(['/login']);
        }, 2000);
      },
      error: (error) => {
        this.tosterService.error(error.error.message);
        console.error('Error during logout:', error);
        this.SpinnerService.hide();
        // alert('An error occurred while logging out.');
      },
    });
  }
  showToast(): void {
    const toast = document.getElementById('customToast');
    if (toast) {
      toast.classList.add('show');
      setTimeout(() => {
        toast.classList.remove('show');
      }, 2000);
    }
  }
}
